<div class="app-account-confirmation">
  @if (isLoading()) {
    <div class="app-account-confirmation__loading">
      <div class="app-account-confirmation__loading-card">
        <aprova-loading-bar title="Confirmando sua conta..." />
      </div>
    </div>
  }

  @if (isSuccess()) {
    <div class="app-account-confirmation__success">
      <div class="app-account-confirmation__success__icon">
        <aprova-icon name="check-circle-solid" size="lg" color="currentColor" />
      </div>
      <div class="app-account-confirmation__success__content">
        <p class="app-account-confirmation__success__title">Conta confirmada com sucesso!</p>
        <p class="app-account-confirmation__success__subtitle">
          Sua conta foi validada. Você será redirecionado para o login em instantes.
        </p>
      </div>
    </div>
  }
</div>
